import * as React from 'react';
import { IIconProps } from '@fluentui/react';
import { TooltipHost, ITooltipHostStyles } from '@fluentui/react/lib/Tooltip';
import { IconButton } from '@fluentui/react/lib/Button';
import { useId } from '@fluentui/react-hooks';
import { IActionButtonProps } from 'src/notifications/models/IActionButtonProps';

const dismissIcon: IIconProps = { iconName: 'Delete', styles: { root: { paddingBottom: '10px' } } };

const calloutProps = { gapSpace: 0 };
const hostStyles: Partial<ITooltipHostStyles> = { root: { display: 'inline-block' } };

export const ActionButton: React.FunctionComponent<IActionButtonProps> = (props) => {
  const tooltipId = useId('tooltip');

  const { disabled, onClick } = props;

  return (
    <div>
      <TooltipHost content='Dismiss' id={tooltipId} calloutProps={calloutProps} styles={hostStyles}>
        <IconButton
          iconProps={dismissIcon}
          aria-label='Dismiss notification'
          onClick={onClick}
          disabled={disabled}
        />
      </TooltipHost>
    </div>
  );
};
